import { Text } from '@billda/design-system';
import type { SiteFileDto } from '../../api/filesApi';
import { getFileIcon } from './fileIcons';
import { formatFileSize } from './formatFileSize';

interface FileRowProps {
  file: SiteFileDto;
  onClick?: () => void;
}

export function FileRow({ file, onClick }: FileRowProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick?.();
        }
      }}
      className="flex cursor-pointer items-center gap-3 border-b border-border-default px-4 py-3 hover:bg-surface-raised sm:px-6"
      data-testid={`file-row-${file.id}`}
    >
      {getFileIcon(file.contentType, 16)}
      <Text variant="body2" noWrap className="min-w-0 flex-1">
        {file.name}
      </Text>
      <Text
        variant="caption"
        color="secondary"
        className="hidden shrink-0 sm:block"
      >
        {formatFileSize(file.fileSizeBytes)}
      </Text>
      <Text
        variant="caption"
        color="secondary"
        className="hidden shrink-0 sm:block"
      >
        {file.uploaderName}
      </Text>
      <Text variant="caption" color="secondary" className="shrink-0">
        {new Date(file.uploadedAt).toLocaleDateString()}
      </Text>
    </div>
  );
}
